module.exports = __webpack_public_path__ + "static/media/fabrika-lukavec-de-bondt-43.341dc58f.JPG";